import styles from "./UnauthorizedPage.module.css";
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = ({title, message}) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className={styles.notFoundContainer}>
      <h1 className={styles.notFoundTitle}>{title}</h1>
      <p className={styles.notFoundMessage}>
        {message}
      </p>
      {/* <div className={styles.goBackButton}>
        <button onClick={goBack}>Go Back</button>
      </div> */}
    </div>
  );
};

export default UnauthorizedPage;
